import { acceptStringValue } from '../../field-viewer/shared-normalizers';
import { validateBirthdate } from './contacts-birthdate/contacts-birthdate-validation';
export const contactsBirthdateViewer = {
    autoComplete: 'bday',
    normalizeLoadedValue: acceptStringValue,
    runAdditionalValidation: validateBirthdate
};

//# sourceMappingURL=definition-viewer.js.map